import styled from 'styled-components'

const StyledTimeline = styled.main`
  background-color: var(--color-gray-900);
  border-radius: 4px;
  border: 0.625rem solid var(--color-white);
  margin: 0 auto;
  max-width: 43.75rem;
  min-height: calc(100vh - 42px);

  @media screen and (min-width: 37.5em) {
    min-height: calc(100vh - 66px);
  }

  .event-icon {
    width: 16px;
  }

  .event-details {
    p {
      margin-top: 0;
    }

    img {
      max-width: 100%;
    }
  }
`

export default StyledTimeline
